<template>
  <el-dialog width="680px" title="可选模块"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="modulesVisible"  append-to-body>
    <div class="details">
        <ul>
          <li v-for="item in modules_list">
              <div class="field_name">
                <span  v-text="item.module_name+':'"></span>
              </div>
              <div class="field_value" v-if="item.module_code == 13">
               <div class="field_value_number">
                 <el-input-number style="width: 100px;margin-right: 8px" size="mini" v-model="value_code" @focus="handleChangeValueCode($event,item)" :max="99" :min="1" :controls="false" placeholder="请输入">

                 </el-input-number>
                 <div class="day">天</div>
               </div>
                <span v-if="list.value_code == '0'" @click="handleClickModule(item,list)" :class="item.module_value_id == list.id ? 'active' : ''" v-for="(list,listIndex) in item.module_values" :key="listIndex" v-text="list.module_value"></span>
              </div>
              <div class="field_value" v-else>
                  <span @click="handleClickModule(item,list)" :class="item.module_value_id == list.id ? 'active' : ''" v-for="list in item.module_values" v-text="list.module_value"></span>
              </div>
          </li>
        </ul>


    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>

import {mapState} from "vuex";
export default {
  name: 'product_add',
  props: {
    modulesVisible: {
      type: Boolean,
      default: false,
    },
    modulesInfo: {
      type: Array,
      default: null,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      modules_list:[],
      value_code:undefined,
    }
  },

  created() {
    if(this.modulesInfo){

      this.modules_list = JSON.parse(JSON.stringify(this.modulesInfo))
      this.modules_list.forEach((item,key)=>{
          if(item.module_values){
            item.module_values.forEach((list,index)=>{
              if(!item.module_value_id && item.module_code != '13'){
                this.$set(item,'module_value_id',list.id)
                this.$set(item,'module_value',list.module_value)
                this.$set(item,'value_code',list.value_code)
              }
              if(item.module_code == '13' && item.value_code != '0'){
                this.value_code = item.value_code ? Number(item.value_code) : undefined
              }
            })
          }
      })
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    handleChangeValueCode(value,item){
      this.$set(item,'module_value_id','0')
      this.$set(item,'value_code',this.value_code)
    },
    handleClickModule(item,list){
      if(item.module_code == 13){
        this.value_code = undefined
      }
      this.$set(item,'module_value_id',list.id)
      this.$set(item,'module_value',list.module_value)
      this.$set(item,'value_code',list.value_code)
    },

    handleClickConfirm(){
      let flag = false
      this.modules_list.forEach((item)=>{
        if(item.module_code == '13'){
          if(item.value_code != '0'){
            if(!this.value_code){
              this.$message.error('请输入最长离线运行时间')
              flag = true
            }
            item.value_code = this.value_code
            item.module_value = `${this.value_code}天`
            item.module_value_id = '0'
          }
        }
      })
      if(flag){return false}
      this.$emit('success',this.modules_list)
      this.$emit('update:modulesVisible', false)
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:modulesVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.details{
  width: 100%;
}
.details ul{
  border-bottom: 1px solid #c5c5c5;
  box-sizing: border-box;
}
.details ul li{
  border: 1px solid #c5c5c5;
  border-bottom: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.details ul li .field_name{
  width: 192px;
  border-right: 1px solid #c5c5c5;
  padding: 5px;
  box-sizing: border-box;
  font-size: 13px;
  display: flex;
  align-items: center;
  font-weight: bold;


}
.details ul li .field_value{
  width: calc(100% - 192px);
  padding: 5px 8px 0;
  box-sizing: border-box;
}
.details ul li .field_value .field_value_number{
  display: inline-block;
  position: relative;
}
.details ul li .field_value .field_value_number .day{
  position: absolute;
  right: 12px;
  top: 0px;
  line-height: 28px;
}
.details ul li .field_value span{
  display: inline-block;
  padding: 0 6px;
  line-height: 22px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  cursor: pointer;
  color: #333333;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 12px;
}
.details ul li .field_value span.active{
  background: rgba(25, 144, 255, 0.16);
  border-color: #1990FF;
  color: #1990ff;
}
</style>
